import React, { useMemo } from 'react';

const PermissionsContext = React.createContext(null);


function PermissionsProvider({ children }) {
  const contextValue = useMemo(() => ({}), []);
  return <PermissionsContext.Provider value={contextValue}>{children}</PermissionsContext.Provider>;
}

PermissionsProvider.displayName = 'PermissionsProvider';
export { PermissionsContext, PermissionsProvider };
